import { CIcon } from '~/icons/types'

export const ciAirsports: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.37 10.341h-1.19v-.09a.49.49 0 0 0-.98 0v.09h-1.19a.49.49 0 1 0 0 .98h1.19v.92l-5.57-.4v-2.04h2.11v.16a.49.49 0 1 0 .98 0v-1.49h.55a.49.49 0 0 0 0-.98h-.56a.493.493 0 0 0-.96 0h-.56a.49.49 0 1 0 0 .98h.55v.35h-2.11v-.8a1.552 1.552 0 0 0-1.52-1.58H9.88a1.552 1.552 0 0 0-1.52 1.58v.8H6.07v-.35h.54a.49.49 0 0 0 0-.98h-.55a.5.5 0 0 0-.48-.38.493.493 0 0 0-.48.38h-.56a.49.49 0 1 0 0 .98h.55v1.49a.49.49 0 1 0 .98 0v-.16h2.29v2.04l-5.57.4v-.92h1.19a.49.49 0 1 0 0-.98H2.77a.491.491 0 0 0-.94 0H.62a.49.49 0 1 0 0 .98h1.19v2.91a.49.49 0 1 0 .98 0v-.21h5.57v.05a1.568 1.568 0 0 0 .79 1.38 2.312 2.312 0 0 0-.45 1.12h-.5a.5.5 0 0 0 0 .99h1.9a.5.5 0 0 0 0-.99h-.4a1.15 1.15 0 0 1 .43-.72 1.18 1.18 0 0 1 .5-.2h3.18c.15.04.41.28.49.92h-.43a.5.5 0 0 0 0 .99h1.91a.5.5 0 0 0 0-.99h-.48c-.037-.41-.16-.81-.36-1.17a1.58 1.58 0 0 0 .69-1.32v-.06h5.57v.21a.5.5 0 0 0 .99 0v-2.91h1.19a.491.491 0 0 0 .49-.49.5.5 0 0 0-.5-.49ZM12 13.221a2.175 2.175 0 1 1 2.17-2.18 2.185 2.185 0 0 1-2.17 2.18Z'
    },
    {
      d: 'M12 9.781a1.265 1.265 0 1 0-.01 2.53 1.265 1.265 0 0 0 .01-2.53Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'airsports',
  type: 'solid'
}
